import { render, staticRenderFns } from "./AssistanceView.vue?vue&type=template&id=1c99a3e3&"
import script from "./AssistanceView.vue?vue&type=script&lang=js&"
export * from "./AssistanceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports